import { render, staticRenderFns } from "./FileInfoModal.vue?vue&type=template&id=f2a58880&scoped=true"
import script from "./FileInfoModal.vue?vue&type=script&lang=js"
export * from "./FileInfoModal.vue?vue&type=script&lang=js"
import style0 from "./FileInfoModal.vue?vue&type=style&index=0&id=f2a58880&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a58880",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2a58880')) {
      api.createRecord('f2a58880', component.options)
    } else {
      api.reload('f2a58880', component.options)
    }
    module.hot.accept("./FileInfoModal.vue?vue&type=template&id=f2a58880&scoped=true", function () {
      api.rerender('f2a58880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/FileInfoModal.vue"
export default component.exports